<template>
  <fragment>
    <iframe style="border:none;" src="https://recruitcrm.io/jobs/campuskraft_jobs"></iframe>
  </fragment>
</template>

<script>
import CLayout from "@/layouts/LayoutAlternative.vue";
export default {
  name: "Jobs",
  created() {
    this.$emit("update:layout", CLayout);
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  iframe {
    height: 900px;
    width: 90vw;
    margin-top: 15%;
    margin-left: 5%;
  }
}
@media (min-width: 600px) {
  iframe {
    height: 980px;
    width: 900px;
    max-width: 90%;
    max-height: 90%;
    margin-top: 10%;
    margin-left: 20%;
  }
}
</style>
